import styled from '@emotion/styled'
import type { ReactElement, ReactNode } from 'react'

import type { ArcadeIcon } from '@arcade/web/icons/react'
import { LinkOutIcon } from '@arcade/web/icons/react'

import CardItem from '../CardItem'
import { LinkAndAnchorStyles } from '../styles'

const StyledAnchor = styled.a<{ disabled?: boolean }>`
  ${LinkAndAnchorStyles}

  ${({ disabled }) =>
    disabled &&
    `
    pointer-events: none;
    cursor: not-allowed;
    opacity: 0.7;
  `}
`

export type ICardItemExternalAnchor = {
  title: string
  subtitle?: string | ReactNode
  icon?: ArcadeIcon | ReactElement
  to?: string
  newTab?: boolean
  onClickTrackEvent?: (e: React.MouseEvent<HTMLAnchorElement>) => void
  'data-testid'?: string
  disabled?: boolean
}

export default function CardItemExternalAnchor({
  to,
  newTab,
  title,
  subtitle,
  icon,
  onClickTrackEvent,
  disabled,
  'data-testid': dataTestId,
}: ICardItemExternalAnchor) {
  const cardProps = { title, subtitle }
  return (
    <StyledAnchor
      href={disabled ? undefined : to}
      data-testid={dataTestId}
      onClick={disabled ? undefined : onClickTrackEvent}
      target={newTab ? '_blank' : '_self'}
      referrerPolicy="same-origin"
      disabled={disabled}
    >
      <CardItem {...cardProps} isClickable={!disabled} icon={icon ?? (LinkOutIcon as ArcadeIcon)} />
    </StyledAnchor>
  )
}
